<template>
  <o-view>
    <o-nav-bar
      title="Consent"
      :has-back-button="true"
    />
    <o-section>
      <o-reseller-badge/>
    </o-section>
    <o-section>
      <o-button
        label="Volgende"
        to="/consentolympus"
        :is-primary="true"
      />
    </o-section>
  </o-view>
</template>

<script>
export default {
  name: 'ConsentKBC'
}
</script>
